<template>
  <v-row>

    <template v-if="loading_folders">
      <v-col md="4" v-for="(i, index) in 3" :key="'skeleton-' + index">
        <CardSkeletonList />
      </v-col>
    </template>

    <template v-else>

      <v-col v-for="(folder, index) in folders" :key="index" cols="12" sm="6" md="3">
        <CardFolder :folder="folder" @click="$emit('open-folder', folder)" @editItem="$emit('editItem', folder)"
          @deleteItem="$emit('deleteItem', folder)" :legajo_id="legajo_id" />
      </v-col>
      <v-col cols="12" v-if="!folders || folders.length === 0">
        <ListEmpty />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import CardSkeletonList from '../CardSkeletonList.vue' ;
import CardFolder from './CardFolder.vue';
import ListEmpty from './ListEmpty.vue';

export default {
  name: 'ListFolder',
  components: {
    CardFolder,
    ListEmpty,
    CardSkeletonList
  },
  props: {
    legajo_id: {
      type: [Number, String],
      default:null
    },
    folders: {
      type: Array,
      required: true
    },
    loading_folders: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Function,
      default: () => { }
    },
    deleteItem: {
      type: Function,
      default: () => { }
    }
  }
}
</script>
